/**
 * Rich Text Element
 */

import type { ElementDefinition } from '@ai-content-hub/content-kit';
import { richTextElementSchema, type RichTextElementData } from './schema';
import { RichTextEdit } from './RichTextEdit';
import { RichTextPlayer } from './RichTextPlayer';

export { richTextElementSchema, type RichTextElementData };
export { RichTextEdit };
export { RichTextPlayer };
export { detectRichTextFormat, looksLikeMarkdown, getMarkdownString } from './detect';
export { normalizeImportedTiptapContent } from './importNormalize';

export const richTextElement: ElementDefinition<RichTextElementData, void> = {
    schema: richTextElementSchema,
    EditComponent: RichTextEdit as any,
    PlayerComponent: RichTextPlayer as any,
};
